import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./overviewHighlights.html";
import { parseNewLines } from '~/modules/utilities/text';

/**
 * v2 Highlights leaf — the numbered-box redesign used by the Overview v2 tab.
 *
 * This is a NET-NEW component, deliberately NOT a fork of `wds/highlights`.
 * `wds/highlights` (the colored-divider tiles) is still rendered by the frozen
 * v1 Overview panel; editing it in place would change v1. This component owns
 * the v2 look-and-feel (numbered cards, 1..N) and can evolve independently.
 *
 * Numbering is derived from the array index at render time (`i + 1`), so callers
 * pass a plain `string[]` exactly as they do for `wds/highlights`.
 */
class OverviewHighlights extends LightningElement {
  constructor(...args) {
    super(...args);
    this.highlights = void 0;
    this.highlightsLabel = void 0;
  }
  // The label is optional: in the v2 Overview tab the numbered cards sit under
  // the shared "Features" section heading and carry no heading of their own, so
  // callers omit `highlightsLabel` and no stray empty <h3> should render.
  get hasLabel() {
    return (this.highlightsLabel?.trim().length ?? 0) > 0;
  }
  get numberedHighlights() {
    return (this.highlights ?? []).filter(Boolean).map((highlight, index) => ({
      key: `${index}-${highlight}`,
      number: index + 1,
      text: parseNewLines(highlight)
    }));
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(OverviewHighlights, {
  publicProps: {
    highlights: {
      config: 0
    },
    highlightsLabel: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(OverviewHighlights, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;